<template>
  <r-carousel
    infinite
    animated
    swipeable
    navigation
    arrows
    :autoplay="5000"
    navigation-icon="radio_button_unchecked"
    navigation-active-icon="circle"
    control-color="riseup-black"
    height="393px" >
    <slot/>
  </r-carousel>
</template>

<script>
import RCarousel from '@/components/base/RCarousel';

export default {
  name: 'ProductGalleryCarousel',
  components: { RCarousel },
};
</script>
